/**
 * Utility to generate and manage unique application numbers for Online Manipal applications.
 * Formats sequentially: Manipal-University-27001, Manipal-University-27002, ... Manipal-University-2700N
 */

const PREFIX = 'Manipal-University-';
const START_NUMBER = 27001;
const STORAGE_KEY_LAST = 'manipal_last_app_no';
const STORAGE_KEY_TXN_PREFIX = 'manipal_app_id_';

export function getOrCreateApplicationNo(txnId) {
  // If transaction ID is available, check if an application number was already generated for this payment
  if (txnId) {
    const existingAppNo = localStorage.getItem(`${STORAGE_KEY_TXN_PREFIX}${txnId}`);
    if (existingAppNo) {
      return existingAppNo;
    }
  }

  // Retrieve current sequential counter from localStorage
  let lastNo = parseInt(localStorage.getItem(STORAGE_KEY_LAST), 10);
  if (isNaN(lastNo) || lastNo < START_NUMBER) {
    lastNo = START_NUMBER;
  } else {
    lastNo = lastNo + 1;
  }

  const newAppNo = `${PREFIX}${lastNo}`;

  // Persist counter and transaction mapping
  try {
    localStorage.setItem(STORAGE_KEY_LAST, lastNo.toString());
    if (txnId) {
      localStorage.setItem(`${STORAGE_KEY_TXN_PREFIX}${txnId}`, newAppNo);
    }
  } catch (err) {
    console.error('LocalStorage write error:', err);
  }

  return newAppNo;
}
